// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlayIcon__icon-f65b0f {
  --load-stroke-width: 2px;
  flex-shrink: 0;
  vertical-align: middle;
  fill: currentColor;
  width: 48px;
  height: 48px;
}

.PlayIcon__progress-bb3b50,
.PlayIcon__infinity-f630a5 {
  stroke-linecap: round;
  fill: transparent;
  transform-box: fill-box;
  transform-origin: center;
  stroke-width: 2px;
}

.PlayIcon__progress-bb3b50 {
  transform: rotate(-90deg);
  stroke-dasharray: 100;
}

.PlayIcon__infinity-f630a5 {
  animation: PlayIcon__dash-bf1c64 1.5s ease-in-out infinite, PlayIcon__rotate-d7b371 2s linear infinite;
}

.PlayIcon__pointer-cdee59 {
  cursor: pointer;
}

.PlayIcon__play-icon-0-b0baa4 {
  fill: var(--brand-primary-40);
}

.PlayIcon__play-icon-bkg-0-ab2047 {
  fill: var(--brand-primary-40);
}

.PlayIcon__play-icon-ic-0-dfd00b {
  fill: white;
}

.PlayIcon__play-icon-error-0-ab5cf1 {
  fill: var(--danger-40);
}

.PlayIcon__play-icon-progress-0-afa914,
.PlayIcon__play-icon-infinity-0-b61664 {
  stroke: var(--addition-50);
}

.PlayIcon__play-icon-1-f48829 {
  fill: var(--brand-primary-40);
}

.PlayIcon__play-icon-bkg-1-d1b57b {
  display: none;
}

.PlayIcon__play-icon-ic-1-e2e6d8 {
  fill: white;
}

.PlayIcon__play-icon-error-1-e52930 {
  fill: var(--danger-40);
}

.PlayIcon__play-icon-progress-1-c8ee2b,
.PlayIcon__play-icon-infinity-1-d5e93e {
  stroke: var(--addition-50);
}

.PlayIcon__play-icon-chat-dde9a8 {
  fill: var(--file-ic-primary-color);
}

.PlayIcon__play-icon-bkg-chat-ac5b6a {
  fill: var(--file-ic-primary-color);
}

.PlayIcon__play-icon-ic-chat-bbb244 {
  fill: var(--file-ic-secondary-color);
}

.PlayIcon__play-icon-error-chat-deeb81 {
  fill: var(--file-ic-secondary-color);
}

.PlayIcon__play-icon-progress-chat-f63d48,
.PlayIcon__play-icon-infinity-chat-c1a45d {
  stroke: var(--file-ic-secondary-color);
}

@keyframes PlayIcon__rotate-d7b371 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes PlayIcon__dash-bf1c64 {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PlayIcon/PlayIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,sGAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;;EAEE,0BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;;EAEE,0BAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;;EAEE,sCAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,wBAAA;IACA,oBAAA;EAAF;EAEA;IACE,yBAAA;IACA,sBAAA;EAAF;EAEA;IACE,yBAAA;IACA,uBAAA;EAAF;AACF","sourcesContent":[".icon {\n  --load-stroke-width: 2px;\n  flex-shrink: 0;\n  vertical-align: middle;\n  fill: currentColor;\n  width: 48px;\n  height: 48px;\n}\n\n.progress,\n.infinity {\n  stroke-linecap: round;\n  fill: transparent;\n  transform-box: fill-box;\n  transform-origin: center;\n  stroke-width: 2px;\n}\n\n.progress {\n  transform: rotate(-90deg);\n  stroke-dasharray: 100;\n}\n\n.infinity {\n  animation: dash 1.5s ease-in-out infinite, rotate 2s linear infinite;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.play-icon-0 {\n  fill: var(--brand-primary-40);\n}\n\n.play-icon-bkg-0 {\n  fill: var(--brand-primary-40);\n}\n\n.play-icon-ic-0 {\n  fill: white;\n}\n\n.play-icon-error-0 {\n  fill: var(--danger-40);\n}\n\n.play-icon-progress-0,\n.play-icon-infinity-0 {\n  stroke: var(--addition-50);\n}\n\n.play-icon-1 {\n  fill: var(--brand-primary-40);\n}\n\n.play-icon-bkg-1 {\n  display: none;\n}\n\n.play-icon-ic-1 {\n  fill: white;\n}\n\n.play-icon-error-1 {\n  fill: var(--danger-40);\n}\n\n.play-icon-progress-1,\n.play-icon-infinity-1 {\n  stroke: var(--addition-50);\n}\n\n.play-icon-chat {\n  fill: var(--file-ic-primary-color);\n}\n\n.play-icon-bkg-chat {\n  fill: var(--file-ic-primary-color);\n}\n\n.play-icon-ic-chat {\n  fill: var(--file-ic-secondary-color);\n}\n\n.play-icon-error-chat {\n  fill: var(--file-ic-secondary-color);\n}\n\n.play-icon-progress-chat,\n.play-icon-infinity-chat {\n  stroke: var(--file-ic-secondary-color);\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `PlayIcon__icon-f65b0f`,
	"progress": `PlayIcon__progress-bb3b50`,
	"infinity": `PlayIcon__infinity-f630a5`,
	"dash": `PlayIcon__dash-bf1c64`,
	"rotate": `PlayIcon__rotate-d7b371`,
	"pointer": `PlayIcon__pointer-cdee59`,
	"play-icon-0": `PlayIcon__play-icon-0-b0baa4`,
	"playIcon0": `PlayIcon__play-icon-0-b0baa4`,
	"play-icon-bkg-0": `PlayIcon__play-icon-bkg-0-ab2047`,
	"playIconBkg0": `PlayIcon__play-icon-bkg-0-ab2047`,
	"play-icon-ic-0": `PlayIcon__play-icon-ic-0-dfd00b`,
	"playIconIc0": `PlayIcon__play-icon-ic-0-dfd00b`,
	"play-icon-error-0": `PlayIcon__play-icon-error-0-ab5cf1`,
	"playIconError0": `PlayIcon__play-icon-error-0-ab5cf1`,
	"play-icon-progress-0": `PlayIcon__play-icon-progress-0-afa914`,
	"playIconProgress0": `PlayIcon__play-icon-progress-0-afa914`,
	"play-icon-infinity-0": `PlayIcon__play-icon-infinity-0-b61664`,
	"playIconInfinity0": `PlayIcon__play-icon-infinity-0-b61664`,
	"play-icon-1": `PlayIcon__play-icon-1-f48829`,
	"playIcon1": `PlayIcon__play-icon-1-f48829`,
	"play-icon-bkg-1": `PlayIcon__play-icon-bkg-1-d1b57b`,
	"playIconBkg1": `PlayIcon__play-icon-bkg-1-d1b57b`,
	"play-icon-ic-1": `PlayIcon__play-icon-ic-1-e2e6d8`,
	"playIconIc1": `PlayIcon__play-icon-ic-1-e2e6d8`,
	"play-icon-error-1": `PlayIcon__play-icon-error-1-e52930`,
	"playIconError1": `PlayIcon__play-icon-error-1-e52930`,
	"play-icon-progress-1": `PlayIcon__play-icon-progress-1-c8ee2b`,
	"playIconProgress1": `PlayIcon__play-icon-progress-1-c8ee2b`,
	"play-icon-infinity-1": `PlayIcon__play-icon-infinity-1-d5e93e`,
	"playIconInfinity1": `PlayIcon__play-icon-infinity-1-d5e93e`,
	"play-icon-chat": `PlayIcon__play-icon-chat-dde9a8`,
	"playIconChat": `PlayIcon__play-icon-chat-dde9a8`,
	"play-icon-bkg-chat": `PlayIcon__play-icon-bkg-chat-ac5b6a`,
	"playIconBkgChat": `PlayIcon__play-icon-bkg-chat-ac5b6a`,
	"play-icon-ic-chat": `PlayIcon__play-icon-ic-chat-bbb244`,
	"playIconIcChat": `PlayIcon__play-icon-ic-chat-bbb244`,
	"play-icon-error-chat": `PlayIcon__play-icon-error-chat-deeb81`,
	"playIconErrorChat": `PlayIcon__play-icon-error-chat-deeb81`,
	"play-icon-progress-chat": `PlayIcon__play-icon-progress-chat-f63d48`,
	"playIconProgressChat": `PlayIcon__play-icon-progress-chat-f63d48`,
	"play-icon-infinity-chat": `PlayIcon__play-icon-infinity-chat-c1a45d`,
	"playIconInfinityChat": `PlayIcon__play-icon-infinity-chat-c1a45d`
};
module.exports = ___CSS_LOADER_EXPORT___;
